import request from '../utils/ai_request';

// 获取会话列表
export async function conversations(params) {
    return request.post(`/ext/dify/chat/conversations`,params);
}

// 删除会话
export async function deleteConversations(params) {
    return request.delete(`/dify/chat/${params.agentId}/conversations/${params.id}/${params.user}`,{
        // data:JSON.stringify(params),
        headers: {
            'Content-Type':'application/json'
        }
    });
}

// 会话重命名
export async function conversationsName(conversation_id, name, user,agentId) {
    return request.post(`/dify/chat/${agentId}/conversations/${conversation_id}/name`, {
        name,
        user,
    });
}